module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Kettle-99cf4d054aaab59e2d495f407b137525.svg";